<template>

  <v-container class="pt-0 pb-5">
    <v-row>
      <v-col cols="12">
        <div class="pa-2 rounded elevation-1 bg-white">
          <SportipsButton backButton chevronLeft>Retour</SportipsButton>
          <div class="text-h5 font-weight-bold my-2">Les participants</div>
          <!-- Liste des inscriptions -->
          <InscriptionsList mode="public" v-if="show_liste_inscrits"></InscriptionsList>
        </div>
      </v-col>
    </v-row>
  </v-container>

</template>

<script>
import { mapStores } from "pinia";
import { useMainStore } from "@/stores/mainStore";
import InscriptionsList from "@/components/ListInscriptions/InscriptionsList.vue";

export default {
  components: { InscriptionsList },
  data() {
    return {};
  },
  computed: {
    ...mapStores(useMainStore),
    show_liste_inscrits() {
      if (!this.mainStore || !this.mainStore.module) {

        return false;
      }
      const has_preinscription = this.mainStore.module.has_preinscription || this.mainStore.module.some_races_have_preinscription;
      const has_liste_inscrits_private = this.mainStore.module.has_liste_inscrits_private;
      const hide_list_inscrits = this.mainStore.module.hide_list_inscrits;


      return !(has_preinscription || has_liste_inscrits_private || hide_list_inscrits);
    }
  },
  methods: {},
  mounted() {
    const has_preinscription = this.mainStore.module.has_preinscription || this.mainStore.module.some_races_have_preinscription;
    const has_liste_inscrits_private = this.mainStore.module.has_liste_inscrits_private;
    const hide_list_inscrits = this.mainStore.module.hide_list_inscrits;
    if (has_preinscription || has_liste_inscrits_private || hide_list_inscrits) {
      this.$router.push({ name: "Home" });
    }
  },
};
</script>

<style lang="scss" scoped></style>